export default __webpack_public_path__ + "static/media/nursery2.06d479fe.jpg";